var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeskIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 798.63,
    height: 559.48,
    viewBox: "0 0 798.63 559.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#f7941d;stroke-miterlimit:10;}.cls-2{fill:#5eb3b7;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21{stroke-width:0px;}.cls-3{fill:#629499;}.cls-4{fill:#543e36;}.cls-5{fill:#3ea0aa;}.cls-6{fill:#0c4b5b;}.cls-7{fill:#167a9a;}.cls-8{fill:#c6dee0;}.cls-9{fill:#d6e5e5;}.cls-10{fill:#c0dbdb;}.cls-11{fill:#a7c9c9;}.cls-12{fill:#cea28b;}.cls-13{fill:#8bafb3;}.cls-14{fill:#90b2b6;}.cls-15{fill:#2f8c9b;}.cls-16{fill:#6a999e;}.cls-17{fill:#ee9c30;}.cls-18{fill:#fff;}.cls-19{fill:#fbb040;}.cls-20{fill:#ebf7f7;}.cls-21{fill:#044154;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m791.58,506.59c-26.62,27.39-152.35,19.03-309.15,24.31-168.1,5.67-280.71,35.78-346.41,18.32-37.74-10.03-147.54-125.48-132.46-148.99,29.44-45.93,245.34-21.59,358.87-53.09,107.86-29.93,169.86-62.01,257.32-19.95,87.47,42.06,199.52,150.9,171.82,179.4Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Desk"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 413.3,
    y: 217.23,
    width: 7.77,
    height: 134.75
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "688.31 286.17 511.01 319.83 262.49 220.37 416.72 215.73 688.31 286.17"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 511.01,
    y: 319.83,
    width: 11.65,
    height: 167.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 677.4,
    y: 288.77,
    width: 10.91,
    height: 167.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 262.61,
    y: 220.68,
    width: 9.23,
    height: 167.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "688.31 286.17 511.34 318.69 511.01 327.83 688.31 292.45 688.31 286.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "511.01 327.83 262.49 227.21 262.49 220.37 511.34 318.69 511.01 327.83"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_23"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "525.94 237.32 519.93 243.54 520.83 250.49 520.93 257.51 632.94 263.79 643.17 225.6 642.44 223.32 642.44 223.32 642.44 223.32 549.12 217.41 525.94 237.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "528.05 240.35 565.15 216.3 650.73 229.32 620.37 258.82 528.05 240.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "515.11 246.68 551.61 216.16 643.2 223.48 614.38 259.58 515.11 246.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "522.46 237.03 561.42 209.72 652.06 224.77 620.27 258.3 522.46 237.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "530.36 222.2 524.78 228.6 527.94 230.02 525.75 235.67 525.96 242.83 632 248.26 641.03 209.24 640.31 206.91 640.31 206.91 640.31 206.91 551.94 201.7 530.36 222.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "526.63 210.43 520.99 217.36 521.67 222.41 521.67 224.29 521.67 226.52 520.99 230.75 626.5 242.62 637.89 204.22 637.31 201.85 637.31 201.85 637.31 201.85 549.43 191.27 526.63 210.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "518.9 214.15 557.24 192.13 642 209.74 610.09 237.56 518.9 214.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "517.85 209.53 556.73 188.48 641.03 208.21 608.43 235.22 517.85 209.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m557.92,186.47l-47.89,16.5c-.26.09-.25.45,0,.53l35.56,11.21c.33.1.48.49.3.79l-.35.58c-.2.34-.04.78.33.9l23.6,7.98c.31.1.64.12.96.06l3.37-.69c.38-.08.77-.06,1.14.04l15.89,4.36c.53.14,1.09.1,1.59-.12l46.64-20.9-81.15-21.24Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_28"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "448.96 235.43 443.63 245.6 436.37 232.37 448.96 235.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "486.93 230.33 391.73 213.57 408.14 142.7 504.44 147.63 486.93 230.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "430.08 219.15 424.07 240.65 443.63 245.6 446.69 221.52 430.08 219.15"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_27"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "592.5 195.36 575.88 202.71 563.06 217.41 563.71 259.91"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 578.34,
    y1: 85.02,
    x2: 575.93,
    y2: 202.9
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m611.08,33.78c-1.28-18.89-16.07-33.01-33.95-32.1-13.92.71-28.55,9.8-31.25,29.69-2.7,19.89,10.65,35.65,15.91,41.9,4.99,5.93,9.21,9.3,15.46,9.75-.91,1.68-1.27,3.59-1.83,4.01-.66.5,1.49,1.82,2.9,1.65,1.4-.17,3.06-.66,3.06-.66,0,0,0-1.14-1.16-2.39-.51-.54-.94-1.78-1.27-2.57,6.53-.33,11.78-7.32,14.91-9.79,3.23-2.56,18.5-20.6,17.22-39.49Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Legs"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m214.96,305.15c15.28-8.26,38.53-27.99,55.93-43.44,5.8-5.15,8.4-11.76,16.7-16.22,5.1-2.74,11.89-1.72,21.41-4.04,22.15-5.38,80.47-22.45,80.47-22.45l5.57,16.23-77.57,23.02-87.21,92.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m322.19,236.35c3.04-1.21,13.87-.57,22.06-.79,19.43-.52,39.17.64,39.17.64l4.65,14.08s-21.27,8.9-32.36,9.74c-11.44.87-20.09-.28-22.18,1.07-10.86,7.05-34.39,82.65-50.54,89.07-13.34,5.31-75.96,16.26-75.96,16.26,0,0,102.24-124.94,115.15-130.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m383.42,236.2l4.65,14.08s4.53,0,5.45-.85c4.81-4.43,8.6-16.83,9.02-18.53.6-2.39-9.54,3.6-9.54,3.6l-9.59,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m393.04,234.35s13.8-3.48,16.92-5.29c2.82-1.63-5.72-31.98-5.72-31.98,0,0-2.62-9.01-7.45-13.49-2.47-2.29-4.92-1.73-4.92.55s1.04,9.91.27,13.93c-1.58,8.29-4.64,14.23-4.64,19.48s5.54,16.8,5.54,16.8Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Coffee_cup"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m259.6,196.3l-2.42,28.63s3.21,1.55,6.67,1.71,14.5,1.24,14.5,1.24l4.58-34.45-22.85-2.83-.48,5.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 258.43,
    y: 190.15,
    width: 25.78,
    height: 1.83,
    transform: "translate(24.98 -31.27) rotate(6.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m260.83,188.15h21.59c.55,0,.99.44.99.99v1.02c0,.22-.18.4-.4.4h-22.99c-.22,0-.4-.18-.4-.4v-.81c0-.66.54-1.2,1.2-1.2Z",
    transform: "translate(24.77 -31.31) rotate(6.91)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Body"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m137.8,198.34s2.19,4.23,2.04,10.02c-.14,5.29-2.04,11.08-2.04,11.08l32.99.92s-4.43-18.09-2.68-22.03c1.75-3.93,15.9-2.37,19.18-6.98,1.55-2.18-1.06-10.47-1.54-18.2-.27-4.33,2.39-5.65,2.03-8.14-.9-6.26-7.5-12.1-8.42-17.83-2.46-15.23-3.05-20.39-5.99-23.61-9.91-10.84-32.36-11.41-45.64-1.75-13.82,10.05-16.26,22.65-17.5,37.74-1.02,12.55,10.46,33.97,27.58,38.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m127.72,235.71s3.57-11.77,10.08-16.26c7.18-4.95,45.55,1,50.01,2.56,5.5,1.93,37.95,120,37.95,120l-22.82,20.41-75.22-126.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m206.19,371.65s40.15-27.67,31.43-40.63c-5.78-8.59-10.41-5.86-21.66-29.79-11.25-23.93-19.38-41.21-19.38-41.21l-9.85,75.08,19.47,36.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m274.89,230.44l-10.96-4.1s-10.87,21.1-15.19,27.78c-4.33,6.68-8.83,13.63-8.83,13.63-7.52-7.94-15.09-15.6-16.4-16.65-6.25-5.05-29.57-28.22-36.63-29.27l-21.79,12.03,27.19,28.36s36.85,24.1,47.54,29.45c6.83,3.43,10.08,4.29,12.87,3.16,4.91-1.99,9.66-19.71,14.12-30.52,4.46-10.82,8.08-33.86,8.08-33.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m258.11,212.58c.89.93,3.65,4.84,4.61,6.87s.78,7.7.78,7.7l11.33,4.84s5.95-3.11,7.7-6.78c2.17-4.57,1.54-17.13-.73-18.23s-4.54,10.01-10.41,8.74-9.9-5.52-9.9-5.52c0,0-2.19-2.86-3.63-1.97s-.63,3.42.26,4.35Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Hair"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m161.72,115.12s-18.49-4.77-32.52,2.56c-13.48,7.04-18.11,17.74-20.54,25.17-2.43,7.43-10.11,62.92-4.7,64.71,5.41,1.79,39.37-2.2,39.37-2.2l2.84-24.67,1.75-15.11s-6.18-2.63-4.44-8.04,7.52-3.54,7.52-3.54l10.73-38.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m150.19,144.08s10.06-4.73,15.78-10.46c5.81-5.81,6.53-11.85,6.53-11.85,0,0-1.97-4.95-13.04-7.17"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Chair_copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m127.48,344.52c-2.7-12.11-6.85-43.01-9.89-55.98s-10.91-34.88-13.65-43.97c-1.55-5.14-1.1-7.13,0-8.99.94-1.6,10.75-3.3,13.6-3.31,3.52-.01,9.54,2.25,16.14,3.99,13.5,3.57,36.71,7.64,38.48,9.2,3.14,2.74,20.01,58.83,21.46,64.03,3.09,11.07,5.76,46.84,9.32,52.94,2.36,4.04,9.58,1.94,16.14.76s62.81-13.04,64.83-13.45c.83-.17,3.78-2.52,5.72-4.99,1.25-1.6,2.37-3.87,2.74-3.78,3.92.95,13.21,7.07,14.07,10.96.88,3.96-.58,6.43-3.9,8.46s-80.63,20.52-93.63,20.54c-13,.01-70.82-14.87-74.09-17.69s-4.29-4.95-7.35-18.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 192.73,
    y: 374.92,
    width: 14.31,
    height: 82.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m195.12,441.72l-69.06,19.09c-2.21.61-3.74,2.62-3.74,4.92v6.95l72.81-15.48v-15.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m201.26,439.91l70.45,13.05c2.26.42,3.96,2.29,4.15,4.58l.6,6.93-73.87-9.13-1.34-15.42Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 275.29,
    cy: 467.22,
    r: 8.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m204.02,445.31l26.64,29.29c.97,1.07,1.51,2.46,1.51,3.9v10.62h-7.85l-31.6-33.97,11.29-9.85Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 229.33,
    cy: 495.33,
    r: 8.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 126.9,
    cy: 478.8,
    r: 8.05
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m572.67,6.3s13.91-1.88,21.89,4.5c7.97,6.38,12.44,15.21,8.87,25.93,0,0-.57-8.04-8.58-17.83-8.51-10.39-22.18-12.61-22.18-12.61Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeskIllustration);
export default __webpack_public_path__ + "static/media/Desk_Illustration.814914138d2e825ac9685e4b69ded13e.svg";
export { ForwardRef as ReactComponent };